import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { BankMutationKeys } from '../../../keys'
import {
	CreateBankAccountRequest,
	CreateBankAccountResponse,
} from '../../../type'
import { createBankAccount } from '../../services'

interface UseMutationCreateBankAccountProps {
	payload: CreateBankAccountRequest
}

export default function useMutationCreateBankAccount(
	props?: UseBaseMutationOptions<
		CreateBankAccountResponse,
		UseMutationCreateBankAccountProps
	>,
) {
	return useMutation({
		mutationKey: [BankMutationKeys.CreateBankAccount],
		mutationFn: (params) => createBankAccount(params.payload),
		...props,
	})
}
